import React from 'react';
import { AppUI } from '@seedlang/state';
import { RouteStore } from '@seedlang/stores';

function syncRouteStore(store, {
  router, routes, params, routeName,
}) {
  if (!store) return;

  if (store.setRouteContext) {
    if (!router) return;
    store.setRouteContext({
      location: router.location,
      routes,
      params,
      push: router.push,
      replace: router.replace,
      createHref: router.createHref,
    });
  } else {
    store.setRouter(router);
  }

  if (routeName) {
    store.setRouteName(routeName);
  }
}

export default function RouteStoreRouterBridge({
  router, routes, params, routeName, children,
}) {
  React.useLayoutEffect(() => {
    const routeContext = {
      router, routes, params, routeName,
    };

    syncRouteStore(RouteStore, routeContext);
    if (AppUI.routeStore !== RouteStore) {
      syncRouteStore(AppUI.routeStore, routeContext);
    }
  }, [params, routeName, router, routes]);

  return children;
}
